import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import { Container, Form, Heading, Link, Page } from '../..';
import { BRAND } from '../../../constants/brand';

import styles from './Contact.module.scss';
import { BOOKING_LINK } from '../../../constants/booking';

interface ContactProps {
  className?: string;
  location?: object;
}

const Contact: FunctionComponent<ContactProps> = ({ className, location }) => {
  const contactClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-contact`,
    className,
    {
      [styles.contact]: true,
    },
  );

  return (
    <Page className={contactClass} location={location}>
      <section className={styles.top}>
        <Container>
          <Heading level={1}>Contact</Heading>
        </Container>
        <section className={styles.booking}>
          <Container>
            <Heading level={3}>Booking Enquiries</Heading>
            <p>
              Ready to get booked in? Our booking system has lots of images,
              kinda like Instagram, if you see something you like, you can book
              in for that specific thing.
            </p>
            <p>
              If you’re not sure what you want, or if you would like to see our
              crystal menu in person, book a deposit appointment.
            </p>
            <p>
              If you can’t find a time or date that works for you, send us an
              email, we may be able to accommodate.
            </p>
            <Link
              external
              to={BOOKING_LINK}
              label="Clicking this link will take you through to our external booking system."
            >
              Book Appointment
            </Link>
          </Container>
        </section>
      </section>
      <section className={styles.contactForm}>
        <Container>
          <Heading level={3}>Let&apos;s Chat</Heading>
          <p>
            Wanna get booked in, ask us some questions or speak about us working
            with you? Send us a message and we will get back to you as soon as
            we can.
          </p>
          <p>
            Please note this isn’t an automated booking service and we will be
            in contact with you to confirm your appointment.
          </p>
          <Form />
        </Container>
      </section>
    </Page>
  );
};

export default Contact;
